var alignmentStyle = {"alignLeft":"TEX-h","textWrapNowrap":"bX-VH","alignRight":"V-3F8","alignCenter":"_6qwxD","sizeFullWidth":"UpfqK","renderedInTable":"_0AcNr","sizeOriginal":"K1HHI","sizeContent":"-OD5G","sizeSmall":"il-Vs","sizeSmallCenter":"ZWVl6","flex":"_6YAKa","LEFT":"VuRHh","CENTER":"_6sVJ3","RIGHT":"qOWoN","AUTO":"SbPYh","JUSTIFY":"qppsL"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-a83ca042.js.map
